module.exports = __webpack_public_path__ + "static/img/index.1b4830f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vubrostand/XS-1/index.png
// module id = +yqV
// module chunks = 0